import { render } from "./XIconSolidStudent.vue?vue&type=template&id=a7ae5258"
import script from "./XIconSolidStudent.vue?vue&type=script&lang=js"
export * from "./XIconSolidStudent.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidStudent.vue"]])

export default __exports__